module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAApklEQVQ4jcWTUQ7DIAxDX3ax9mZJbhZO5n2srUpLq1X7mCVkgcA2CcCPMEnbJDN13ODudqsgCUlEhEZY1rkaJonMlLvTWmOaZlqrHU9k5tDc3e3gjqpqwONkgF57xd55zw2wAy9FXJQewT3IDCKCy+Ldxa6q8xXGMXt2DwCqqm/jmmJcwJ5X55W/7ELPJ4GnItth0PaUR8/4DhGfenR/wcwet/T/eAPPfW2GJWxq0gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/DIR_OPEN.png
// module id = 53
// module chunks = 0